export default __webpack_public_path__ + "static/media/google-logo.e086107b.svg";